import { ShoppingBag } from "@mui/icons-material";
import { Avatar, Grid, Stack, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { formatNumberWithThousandsSeparator } from "../../helpers";
import { ICartItem } from "../../stateManagement/reducers/cartReducer";
import SelectionButton from "./SelectionButton";

interface IProps {
  cartItem: ICartItem;
}

const CartItem: FC<IProps> = ({ cartItem }) => {
  const theme = useTheme();

  return (
    <Grid container direction="row" spacing="space-between">
      <Grid item xs={5}>
        <Stack sx={{ width: "100%" }} alignItems="flex-start">
          <Avatar
            variant="rounded"
            src={
              cartItem.rentalItem?.imgSrc
                ? `${process.env.REACT_APP_SERVER_ENDPOINT}/${cartItem.rentalItem?.imgSrc}`
                : ""
            }
            sx={{
              height: "100%",
              maxHeight: "10rem",
              width: "auto",
              background: theme.palette.primary.main,
              backdropFilter: "blur(10px)",
              "& img": {
                padding: "0 !important",
                width: "100% !important",
                height: "100% !important",
                objectFit: "cover !important",
              },
            }}
            className="shadow-md"
          >
            <ShoppingBag
              sx={{ width: "60%", height: "60%", color: "white !important" }}
            />
          </Avatar>
          <Typography
            variant="body1"
            display="block"
            sx={{
              width: "100%",
              mt: ".5rem !important",
              fontSize: ".8rem !important",
              lineHeight: ".9rem !important",
              textAlign: "center",
            }}
            className="text-grey"
          >
            {cartItem.rentalItem.name}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs>
        <SelectionButton cartItem={cartItem} />
      </Grid>
      <Grid item xs={1}>
        <Stack
          alignItems="flex-end"
          justifyContent="center"
          sx={{ height: "100%" }}
        >
          <Typography
            variant="h6"
            display="block"
            sx={{
              fontSize: "1rem !important",
              lineHeight: "1rem !important",
              color: "black !important",
            }}
          >
            {`₦${formatNumberWithThousandsSeparator(cartItem.count * cartItem.rentalItem.pricePerDay)}`}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CartItem;
